import { ProtestActItemStatus } from 'chaika-enums';
import sortBy from 'lodash/sortBy';
import uniq from 'lodash/uniq';
import { ProtestActItemData } from 'chaika-frontend-types/frontend-cms';

import { LongList } from '@store/abstract/LongList';

interface FilterParams {
    status?: ProtestActItemStatus;
}

export class ProtestItemList extends LongList<ProtestActItemData, ProtestActItemData, FilterParams> {
    public get policyNumbers(): string[] {
        return uniq(this.values.map(v => v.policyNumber));
    }

    protected create(params: ProtestActItemData): ProtestActItemData {
        return params;
    }

    protected filterValue(value: ProtestActItemData, { status }: FilterParams): boolean {
        return this.filterFieldValue(value, status, 'status');
    }

    protected getOrderedValues(params: ProtestActItemData[]): ProtestActItemData[] {
        return sortBy(
            params,
            item => item.status === ProtestActItemStatus.Finish,
            item => item.status === ProtestActItemStatus.InProcess,
            item => item.createdAt,
        );
    }
}
